<template>
    <div id="app">
        <router-view name="header"/>
        <div>
            <router-view :key="$route.fullPath"/>
        </div>
        <router-view name="footer"/>
    </div>
</template>
<script>
  export default {
    methods: {
      cambiarFavicon(url) {
        // Encuentra todos los elementos <link> que pueden ser interpretados como favicons
        const existingIcons = document.querySelectorAll("link[rel='icon'], link[rel='shortcut icon'], link[rel='apple-touch-icon']");
        // Elimina cada uno de estos elementos del <head>
        existingIcons.forEach(icon => icon.parentNode.removeChild(icon));
        
        // Crea o modifica el nuevo <link> para el favicon
        let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.rel = 'icon';
        link.type = 'image/png';
        link.href = `${url}?${new Date().getTime()}`; // Añade un timestamp para prevenir el cache
        document.getElementsByTagName('head')[0].appendChild(link);
      
        // Encuentra y elimina el icono existente para Safari (Apple Touch Icon)
        let linkAppleIcon = document.querySelector("link[rel*='apple-touch-icon']") || document.createElement('link');
        linkAppleIcon.rel = 'apple-touch-icon';
        linkAppleIcon.href = url;
        document.getElementsByTagName('head')[0].appendChild(linkAppleIcon);
      }    
    },
    mounted() {
      console.log("favicon: ",this.$store.state.ruta_favicon)
      this.cambiarFavicon(this.$store.state.ruta_favicon);
    }
  }


  
  
  
  
  
  
</script>

